import { createFeatureSelector, createSelector } from "@ngrx/store";
import { TrainingState } from "./training.model";

export const selectTrainingStateState = createFeatureSelector<TrainingState>('ktraining');
export const userRoll = createSelector(
  selectTrainingStateState,
  state => state.roll
)
export const playChanged = createSelector(
  selectTrainingStateState,
  state => state.play
)

export const taskIndex = createSelector(
  selectTrainingStateState,
  state => state.task_index
)

export const savePlay = createSelector(
  selectTrainingStateState,
  state => state.save_play
)


export const sceneIndex = createSelector(
  selectTrainingStateState,
  state => state.scene_index
)


export const currTime = createSelector(
  selectTrainingStateState,
  state => state.curr_time
)
export const play = createSelector(
  selectTrainingStateState,
  state => state.play_it
)
export const pause = createSelector(
  selectTrainingStateState,
  state => state.pause
)
export const stopRec = createSelector(
  selectTrainingStateState,
  state => state.stop
)
export const rec = createSelector(
  selectTrainingStateState,
  state => state.rec_count
)

export const goToAct = createSelector(
  selectTrainingStateState,
  state => state.act
)

export const zoom = createSelector(
  selectTrainingStateState,
  state => state.zoom
)
export const remoteZoomPan = createSelector(
  selectTrainingStateState,
  state => state.remote_zoom_pan
)

export const sketchIndex = createSelector(
  selectTrainingStateState,
  state => state.sketch_index
)

export const setSketch = createSelector(
  selectTrainingStateState,
  state => state.last_sketch
)
export const user = createSelector(
  selectTrainingStateState,
  state => state.user
)
export const progress = createSelector(
  selectTrainingStateState,
  state => state.progress
)


export const delMoviesFromS3 = createSelector(
  selectTrainingStateState,
  state => state.del_movies
)
export const mimeType = createSelector(
  selectTrainingStateState,
  state => state.mime_type
)
export const mimeExt = createSelector(
  selectTrainingStateState,
  state => state.mime_ext
)

export const otherRec = createSelector(
  selectTrainingStateState,
  state => state.other_rec_count
)
export const gotPatients = createSelector(
  selectTrainingStateState,
  state => state.patients
)
export const setSegment = createSelector(
  selectTrainingStateState,
  state => state.set_segment
)

//////////////
